export default "__VITE_ASSET__CaeCsfXc__"